import {
  PERSONA_CHAT_IMAGE_EXTENSION_TO_MIME,
  PERSONA_CHAT_IMAGE_OUTPUT_MIME_TYPE,
} from '@highlight-cp/constants';

export const normalizeMimeType = (mimeType: string): string => {
  if (mimeType === 'image/jpg') {
    return PERSONA_CHAT_IMAGE_OUTPUT_MIME_TYPE;
  }

  return mimeType;
};

export const resolveFileMimeType = (file: File): string => {
  if (file.type) {
    return normalizeMimeType(file.type);
  }

  const extension = file.name.slice(file.name.lastIndexOf('.')).toLowerCase();

  return PERSONA_CHAT_IMAGE_EXTENSION_TO_MIME[extension] ?? '';
};
